// Constants
let APP_CONST = {};

APP_CONST.LAYOUT_FULL    = 'full';
APP_CONST.LAYOUT_PARTIAL = 'partial';

// Alert constants
APP_CONST.ALERT_TYPE_DANGER  = 'danger';
APP_CONST.ALERT_TYPE_INFO    = 'info';
APP_CONST.ALERT_TYPE_SUCCESS = 'success';
APP_CONST.ALERT_TYPE_WARNING = 'warning';

APP_CONST.ALERT_CLASSES = {};
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_DANGER]  = 'bg-red-50 text-red-700 border-red-600';
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_INFO]    = 'bg-blue-50 text-blue-700 border-blue-600';
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_SUCCESS] = 'bg-emerald-50 text-emerald-700 border-emerald-600';
APP_CONST.ALERT_CLASSES[APP_CONST.ALERT_TYPE_WARNING] = 'bg-yellow-50 text-yellow-700 border-yellow-600';

// Btn constants
APP_CONST.BTN_TYPE_PRIMARY     = 'primary';
APP_CONST.BTN_TYPE_OUTLINE     = 'outline';
APP_CONST.BTN_TYPE_DESTRUCTIVE = 'destructive';
APP_CONST.BTN_TYPE_GHOST       = 'ghost';
APP_CONST.BTN_TYPE_GHOST_DESTRUCTIVE = 'ghost-destructive';

APP_CONST.BTN_CLASSES = {};
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_PRIMARY]     = 'bg-blue-700 border border-blue-700 text-primary-foreground hover:bg-blue-600 hover:border-blue-600 focus-visible:border-white focus-visible:ring-blue-600/40 focus-visible:ring-[3px]';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_OUTLINE]     = 'border border-input bg-white hover:bg-accent hover:text-accent-foreground focus-visible:border-slate-500 focus-visible:ring-slate-400/50 focus-visible:ring-[3px]';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_DESTRUCTIVE] = 'bg-red-600 border-red-600 text-white hover:bg-red-500 border hover:border-red-500 focus-visible:border-white focus-visible:ring-red-600/40 focus-visible:ring-[3px]';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_GHOST]       = 'border border-transparent hover:bg-accent hover:text-accent-foreground focus-visible:border-slate-500 focus-visible:ring-slate-400/50 focus-visible:ring-[3px]';
APP_CONST.BTN_CLASSES[APP_CONST.BTN_TYPE_GHOST_DESTRUCTIVE] = 'border border-transparent text-red-600 hover:bg-red-50 hover:text-red-700 focus-visible:border-red-500 focus-visible:ring-red-600/40 focus-visible:ring-[3px]';

APP_CONST.BTN_SIZE_LG = 'lg';
APP_CONST.BTN_SIZE_SM = 'sm';

// Field constants
APP_CONST.FIELD_TYPE_EMAIL = 'email';
APP_CONST.FIELD_TYPE_PASSWORD = 'password';
APP_CONST.FIELD_TYPE_TEXT = 'text';
APP_CONST.FIELD_TYPE_TEL = 'tel';
APP_CONST.FIELD_TYPE_TOGGLE = 'toggle';
APP_CONST.FIELD_TYPE_SELECT = 'select';

// Flash Keys
APP_CONST.FLASH = {
    SUCCESSFUL_PASSWORD_CHANGE: 'successful_password_change',
};


export { APP_CONST };
export default APP_CONST;